import React, { useState } from 'react';
import './StupidSystemDesigns.css';

const slotBookingsCode = String.raw`
#include <bits/stdc++.h>
using namespace std;
enum class SlotState {FREE, LOCKED, BOOKED};

class Slot{
  int slotId;
  SlotState state;
  int price;
  
  int lockTTL;
  int lockedByUserId;
  
 public:
    Slot(int id){
        slotId=id;
        state=SlotState::FREE;
        lockTTL=-1;
        lockedByUserId=-1;
        price=100; //default 100 for now
    }
    
    SlotState getState(){
        return state;
    }
    int getLockedByUserId(){
        return lockedByUserId;
    }
    int getPrice(){
        return price;
    }
    
    void refreshState(int tick){
        if(state==SlotState::LOCKED && tick>lockTTL){
            state=SlotState::FREE;
            cout << "  [SYSTEM] Slot " << slotId << " lock expired! Freed from User " << lockedByUserId << ".\n";
            lockTTL=-1;
            lockedByUserId=-1;
        }
    }
    
    void lockSlot(int userId, int lock){
        lockedByUserId=userId;
        lockTTL=lock;
        state=SlotState::LOCKED;
    }
    
    void bookSlot(){
        state=SlotState::BOOKED;
    }
};

class User{
    int userId;
    int price; // Represents User's Account Balance
public:
    User(int id, int p){
        userId=id;
        price=p;
    }

    int getPrice(){
        return price;
    }
    void addPrice(int add){
        price+=add;
    }
    void removePrice(int rem){
        price-=rem;
    }
};

class SlotController{
    unordered_map<int, Slot*>slots;
    unordered_map<int, User*>users;
    int tick;
public:
    SlotController(){
      slots={};
      users={};
      tick=0;
    }
   
   // To simulate time.. 
    void advanceTick() {
        tick++;
        cout << "\n=== TICK " << tick << " ===\n";
    }
    
    vector<int>getFreeSlots(){
        vector<int>freeSlots={};
        for(auto &pairs : slots){
            Slot *slot=pairs.second;
            slot->refreshState(tick); // Lazy evaluation of timeouts
            if(slot->getState()==SlotState::FREE){
                freeSlots.push_back(pairs.first);
            }
        }
        return freeSlots;
    }
    
    void addSlot(int slotId){
        Slot *slot=new Slot(slotId);
        slots[slotId]=slot;
        cout << "  [INIT] Added Slot " << slotId << " (Price: 100)\n";
    }
    
    void addUser(int userId, int balance){
        User *user=new User(userId, balance);
        users[userId]=user;
        cout << "  [INIT] Added User " << userId << " (Balance: " << balance << ")\n";
    }
    
    void lockSlot(int slotId, int userId){
        if(!users.count(userId) || !slots.count(slotId)){
            cout << "  [FAIL] Invalid User or Slot ID.\n";
            return;
        }
        
        Slot *slot=slots[slotId];
        slot->refreshState(tick); // Ensure we don't block on an expired lock
        
        if(slot->getState()!=SlotState::FREE){
            cout << "  [FAIL] User " << userId << " cannot lock Slot " << slotId << " - Not FREE.\n";
            return;
        }
        
        slot->lockSlot(userId, tick+5); // locks for 5 ticks
        cout << "  [SUCCESS] User " << userId << " LOCKED Slot " << slotId << " until Tick " << (tick + 5) << ".\n";
    }
    
    void bookSlot(int slotId, int userId){
        if(!users.count(userId) || !slots.count(slotId)){
            cout << "  [FAIL] Invalid User or Slot ID.\n";
            return;
        }
        
        Slot *slot=slots[slotId];
        User *user=users[userId];
        slot->refreshState(tick); // Catch last-second expirations
        
        if(slot->getState()!=SlotState::LOCKED || slot->getLockedByUserId()!=userId){
            cout << "  [FAIL] User " << userId << " does not hold a valid lock on Slot " << slotId << ".\n";
            return;
        }
        
        if(slot->getPrice() > user->getPrice()){
            cout << "  [FAIL] User " << userId << " has insufficient balance to book Slot " << slotId << ".\n";
            return;
        }
        
        slot->bookSlot();
        user->removePrice(slot->getPrice());
        cout << "  [SUCCESS] User " << userId << " BOOKED Slot " << slotId << "! Remaining Balance: " << user->getPrice() << "\n";
    }
};

int main() {
    SlotController controller;
    
    cout << "--- INITIALIZING SYSTEM ---\n";
    controller.addSlot(101);
    controller.addSlot(102);
    
    controller.addUser(1, 500); // User 1 has enough money
    controller.addUser(2, 50);  // User 2 doesn't have enough money for a 100-price slot

    // Simulate Ticks from 1 to 20
    for(int t = 1; t <= 20; t++) {
        controller.advanceTick();
        
        if (t == 2) {
            cout << "  > User 1 checks free slots: ";
            for (int id : controller.getFreeSlots()) cout << id << " "; cout << "\n";
            
            cout << "  > User 1 attempts to lock Slot 101.\n";
            controller.lockSlot(101, 1);
        }
        else if (t == 3) {
            cout << "  > User 2 checks free slots: ";
            for (int id : controller.getFreeSlots()) cout << id << " "; cout << "\n";
            
            cout << "  > User 2 attempts to lock Slot 102.\n";
            controller.lockSlot(102, 2);
        }
        else if (t == 5) {
            cout << "  > User 2 attempts to book Slot 102.\n";
            controller.bookSlot(102, 2); // Should fail (balance is 50, price is 100)
        }
        else if (t == 8) {
            cout << "  > User 1's lock on 101 should expire this tick (2 + 5 = 7).\n";
            cout << "  > System checks free slots to trigger lazy evaluation: ";
            for (int id : controller.getFreeSlots()) cout << id << " "; cout << "\n";
        }
        else if (t == 10) {
            cout << "  > User 1 realizes they forgot to pay and tries to book Slot 101.\n";
            controller.bookSlot(101, 1); // Should fail, lock expired!
        }
        else if (t == 11) {
            cout << "  > User 1 re-locks Slot 101.\n";
            controller.lockSlot(101, 1);
        }
        else if (t == 12) {
            cout << "  > User 1 finally pays and books Slot 101.\n";
            controller.bookSlot(101, 1); // Should succeed!
        }
        else if (t == 20) {
            cout << "  > Final check of free slots before shutdown: ";
            for (int id : controller.getFreeSlots()) cout << id << " "; cout << "\n";
        }
    }
    
    return 0;
}
`;

const stupidSlotBookingsCode = String.raw`
#include <bits/stdc++.h>
using namespace std;
enum class SlotState {FREE, LOCKED, BOOKED, OVERBOOKED};

class Slot {
public:
    int slotId;
    SlotState state;
    int price;
    int lockTTL;
    int lockedByUserId;
    
    Slot(int id) {
        slotId = id;
        state = SlotState::FREE;
        price = 100;
        lockTTL = -1;
        lockedByUserId = -1;
    }
};

class User {
public:
    int userId;
    int balance;
    User(int id, int p) { userId = id; balance = p; }
};

class ChaoticController {
    unordered_map<int, Slot*> slots;
    unordered_map<int, User*> users;
    int tick;
public:
    ChaoticController() { tick = 0; }
    
    void addSlot(int id) { slots[id] = new Slot(id); }
    void addUser(int id, int bal) { users[id] = new User(id, bal); }
    
    void advanceTick() {
        tick++;
        cout << "\n=== TICK " << tick << " ===\n";
        
        for (auto& pair : slots) {
            Slot* slot = pair.second;
            
            if (slot->state != SlotState::BOOKED && slot->state != SlotState::OVERBOOKED) {
                slot->price += 5; 
            }
            
            if (slot->state == SlotState::LOCKED && tick > slot->lockTTL) {
                cout << "  [PENALTY] User " << slot->lockedByUserId 
                     << " wasted our time! Deducting $50 penalty.\n";
                users[slot->lockedByUserId]->balance -= 50;
                
                slot->state = SlotState::FREE;
                slot->lockedByUserId = -1;
                slot->lockTTL = -1;
            }
        }
    }
    
    // 3. Extreme Pessimistic Search
    vector<int> getFreeSlots(int userId) {
        cout << "  [SEARCH] User " << userId << " is looking at slots. Locking ALL of them for 1 tick so no one else can!\n";
        vector<int> freeSlots;
        
        for (auto& pair : slots) {
            Slot* slot = pair.second;
            if (slot->state == SlotState::FREE) {
                freeSlots.push_back(pair.first);
                // Pessimistic locks - YEAH PLS AVOID THIS DUDE
                slot->state = SlotState::LOCKED;
                slot->lockedByUserId = userId;
                slot->lockTTL = tick; // Expires immediately on the next tick
            }
        }
        return freeSlots;
    }
    
    // Lock StealinG
    void lockSlot(int slotId, int userId, int bribe = 0) {
        Slot* slot = slots[slotId];
        
        if (slot->state == SlotState::LOCKED && slot->lockedByUserId != userId) {
            if (bribe > 0) {
                cout << "  [SCANDAL] User " << userId << " bribed the system with $" << bribe 
                     << " to STEAL Slot " << slotId << " from User " << slot->lockedByUserId << "!\n";
                users[userId]->balance -= bribe; // System takes the bribe lmao
                slot->lockedByUserId = userId;
                slot->lockTTL = tick + 5;
                return;
            } else {
                cout << "  [FAIL] Slot locked. (Hint: Try offering a bribe next time).\n";
                return;
            }
        }
        
        if (slot->state == SlotState::FREE) {
            slot->state = SlotState::LOCKED;
            slot->lockedByUserId = userId;
            slot->lockTTL = tick + 5;
            cout << "  [SUCCESS] User " << userId << " safely locked Slot " << slotId << ".\n";
        }
    }
    
    // Overbooking
    void bookSlot(int slotId, int userId) {
        Slot* slot = slots[slotId];
        User* user = users[userId];
        
        if (slot->state == SlotState::BOOKED) {
            cout << "  [WARNING] Slot " << slotId << " is already booked. Booking it anyway as OVERBOOKED! Good luck fighting for the seat.\n";
            slot->state = SlotState::OVERBOOKED;
            user->balance -= slot->price;
            return;
        }
        
        if (slot->state == SlotState::LOCKED && slot->lockedByUserId == userId) {
            if (user->balance >= slot->price) {
                slot->state = SlotState::BOOKED;
                user->balance -= slot->price;
                cout << "  [SUCCESS] User " << userId << " bought Slot " << slotId 
                     << " for an inflated price of $" << slot->price 
                     << ". Remaining balance: $" << user->balance << "\n";
            } else {
                cout << "  [FAIL] User " << userId << " is too broke ($" << user->balance 
                     << ") to pay the inflated price of $" << slot->price << ".\n";
            }
        }
    }
};

int main() {
    ChaoticController sys;
    sys.addSlot(101);
    sys.addUser(1, 300); // Alice
    sys.addUser(2, 300); // Bob
    // Dsa guys who are tired of alice and bob game-theory questions, WANNA PLAY A GAMEEEEEE?????
    
    sys.advanceTick(); // Tick 1
    
    // Alice innocently searches for slots
    vector<int> slots = sys.getFreeSlots(1); 
    
    // Bob tries to lock a slot in the same tick, but Alice's "Search Lock" blocks him!
    cout << "  > Bob tries to lock 101.\n";
    sys.lockSlot(101, 2); 
    
    sys.advanceTick(); // Tick 2 (Alice's search lock expires, price goes up)
    
    cout << "  > Bob tries again and succeeds.\n";
    sys.lockSlot(101, 2); 
    
    sys.advanceTick(); // Tick 3 (Price goes up again)
    
    cout << "  > Alice wants it, so she bribes the system $20.\n";
    sys.lockSlot(101, 1, 20); // Alice steals the lock!
    
    sys.advanceTick(); // Tick 4 (Price goes up again!)
    
    cout << "  > Alice books her stolen slot.\n";
    sys.bookSlot(101, 1);
    
    cout << "  > Bob is angry and books it anyway.\n";
    sys.bookSlot(101, 2); // Triggers OVERBOOKED state

    for(int i=0; i<6; i++) sys.advanceTick(); // Advance to let any remaining locks expire

    return 0;
}
`;

function SlotBookingsDesign({ theme, onBackClick }) {
    const [copied, setCopied] = useState({ good: false, stupid: false });

    const handleCopyCode = async (codeKey, codeText) => {
        try {
            await navigator.clipboard.writeText(codeText);
            setCopied((previous) => ({ ...previous, [codeKey]: true }));
            window.setTimeout(() => {
                setCopied((previous) => ({ ...previous, [codeKey]: false }));
            }, 1800);
        } catch (error) {
            console.error('Copy failed:', error);
        }
    };

    return (
        <div className={`app ${theme}`}>
            <main className="system-design-page">
                <section className="system-designs-header-section">
                    <div className="system-designs-header">
                        <div className="system-designs-header-copy">
                            <h1>Slot Bookings Design</h1>
                            <p className="system-designs-subtitle">
                                Slot bookings template - in inventory bookings like airports, movies, restaurants. It uses optimistic locking - users can temporarily lock slots and must pay within window, else slot is freed.                            </p>
                        </div>
                        <button className="back-btn" onClick={onBackClick}>
                            Back to Designs
                        </button>
                    </div>
                </section>

                <section className="system-designs-content">
                    <div className="system-design-article">
                        <div className="design-section">
                            <h2>Functional Requirements</h2>
                            <ul>
                                <li>Manage a catalog of bookable slots and a registry of users.</li>
                                <li>Allow users to retrieve currently available FREE slots.</li>
                                <li>Temporarily lock a selected slot for one user for 5 time units.</li>
                                <li>Hide locked slots from other users while the lock is valid.</li>
                                <li>Automatically return an expired lock to FREE without active polling.</li>
                                <li>Allow booking only when the user owns a valid lock and has enough wallet balance.</li>
                                <li>Deduct the slot price and transition the slot to BOOKED after payment.</li>
                            </ul>
                        </div>

                        <div className="design-section">
                            <h2>Design</h2>
                            <ul>
                                <li><strong>Tick-based simulation:</strong> time is an integer controlled by the driver, making timeout scenarios deterministic and easy to test.</li>
                                <li><strong>Slot:</strong> owns its ID, price, state, lock expiry tick, and lock owner.</li>
                                <li><strong>User:</strong> owns the account balance used to authorize payment.</li>
                                <li><strong>SlotController:</strong> coordinates slot inventory, user lookup, availability, locks, and bookings.</li>
                                <li><strong>Lazy TTL evaluation:</strong> <code>refreshState</code> checks expiration only when a slot is viewed or modified, avoiding polling threads and wasted CPU cycles.</li>
                                <li><strong>Ownership validation:</strong> booking requires both a LOCKED state and a matching user ID.</li>
                            </ul>
                        </div>


                        <div className="design-section">
                            <h2>Main Entities</h2>
                            <ul>
                                <li>SlotState: FREE, LOCKED, or BOOKED.</li>
                                <li>Slot: bookable inventory item with lazy lock expiration.</li>
                                <li>User: account holder with a wallet balance.</li>
                                <li>SlotController: inventory and booking coordinator with simulated time.</li>
                                <li>tick: deterministic logical clock used to test TTL behavior.</li>
                            </ul>
                        </div>

                        <div className="design-section stupid-design-section">
                            <h2>Stupid Design</h2>
                            <h3>Stupid Design Ideas Used</h3>
                            <ol>
                                <li><strong>Aggressive Pessimistic Locking (The "I saw it first" rule):</strong> If a user even <em>asks</em> to see the free slots, the system temporarily locks <strong>all of them</strong> for 1 tick so no one else can even look at them.</li>
                                <li><strong>Lock Stealing (Bidding War):</strong> If a slot is already locked by Alice, Bob can steal her lock by offering a higher bribe.</li>
                                <li><strong>Anxiety-Inducing Dynamic Pricing:</strong> Every time a tick passes, the price of all unbooked slots increases by $5 (Inflation).</li>
                                <li><strong>The Time-Waster Penalty:</strong> If you lock a slot and let it expire without booking, the system aggressively deducts a $50 "time-waster fee" from your wallet.</li>
                                <li><strong>Overbooking:</strong> You can actually book a slot that is already <code>BOOKED</code>. It just changes the state to <code>OVERBOOKED</code> (we'll let the users physically fight over the seat at the venue).</li>
                            </ol>
                            <div className="design-code-header">
                                <h2>Stupid C++ Sample Code</h2>
                                <button type="button" className="copy-code-btn" onClick={() => handleCopyCode('stupid', stupidSlotBookingsCode)}>
                                    {copied.stupid ? 'Copied!' : 'Copy code'}
                                </button>
                            </div>
                            <pre className="design-code-block"><code>{stupidSlotBookingsCode}</code></pre>
                        </div>


                        <div className="design-section">
                            <div className="design-code-header">
                                <h2>C++ Sample Code</h2>
                                <button type="button" className="copy-code-btn" onClick={() => handleCopyCode('good', slotBookingsCode)}>
                                    {copied.good ? 'Copied!' : 'Copy code'}
                                </button>
                            </div>
                            <pre className="design-code-block"><code>{slotBookingsCode}</code></pre>
                        </div>
                    </div>

                    <div className="system-designs-footer-note">
                        SLOT BOOOOKINGGGGG SLOOOTTTT BOOOOOKINGGGGGGGGGGG
                    </div>

                    <button className="back-btn" onClick={onBackClick}>
                        Back to Designs
                    </button>
                </section>
            </main>

            <footer className="footer">
                <p>© 2026 StupidDesigns.com. All rights reserved. Not that anyone actually wants them.</p>
            </footer>
        </div>
    );
}

export default SlotBookingsDesign;
